import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  BulletList,
  BulletListContent,
  BulletListIcon,
  Button,
  Column,
  GridContainer,
  Li,
  ModalDialogBody,
  ModalDialogButtons,
  ModalDialogFooter,
  ModalDialogHeader,
  ModalDialogTitle,
  Row,
  SelectionSet,
  SelectionSetInput,
  SelectionSetLabel,
  Span,
} from '@vp/swan';
import { useTranslations } from '@vp/om-translations';
import DesignServicesIcon from '../icons/designServices.svg';
import TypeFaceIcon from '../icons/typeFace.svg';
import GuaranteedSatisfactionIcon from '../icons/guaranteedSatisfaction.svg';

export const AddressUpdateTerms = ({ setTermsAccepted }) => {
  const [shippingAddressUpdate] = useTranslations(['shippingAddressUpdate']);

  const [isChecked, setIsChecked] = useState(false);

  const acceptTerms = () => {
    if (isChecked) {
      setTermsAccepted(true);
    }
  };

  return (
    <>
      <ModalDialogHeader>
        <ModalDialogTitle>
          {shippingAddressUpdate.needToUpdate}
        </ModalDialogTitle>
      </ModalDialogHeader>
      <ModalDialogBody>
        <BulletList>
          <Li key="we-will-try-to-update-the-address">
            <BulletListIcon
              src={DesignServicesIcon}
              width={32}
              height={32}
              alt=""
            />
            <BulletListContent>
              {shippingAddressUpdate.weWillTryOurBest}
            </BulletListContent>
          </Li>
          <Li key="address-update-disclaimer">
            <BulletListIcon src={TypeFaceIcon} width={32} height={32} alt="" />
            <BulletListContent>
              {shippingAddressUpdate.pleaseBeAware}
            </BulletListContent>
          </Li>
          <Li key="notification-by-email">
            <BulletListIcon
              src={GuaranteedSatisfactionIcon}
              width={32}
              height={32}
              alt=""
            />
            <BulletListContent>
              {shippingAddressUpdate.receiveAnEmail}
            </BulletListContent>
          </Li>
        </BulletList>
      </ModalDialogBody>
      <ModalDialogFooter pinned>
        <ModalDialogButtons>
          <GridContainer>
            <Row span={10}>
              <Column span={7}>
                <SelectionSet
                  skin="simple-column"
                  variant="multi-select"
                  mt={3}
                >
                  <SelectionSetInput
                    checked={isChecked}
                    onChange={event => setIsChecked(event.target.checked)}
                    data-testid="address-update-accept-terms-checkbox"
                  >
                    <SelectionSetLabel>
                      <Span fontSize="small">
                        {shippingAddressUpdate.termsAccept}
                      </Span>
                    </SelectionSetLabel>
                  </SelectionSetInput>
                </SelectionSet>
              </Column>
              <Column span={3} verticallyCenterContent>
                <Button
                  onClick={acceptTerms}
                  disabled={!isChecked}
                  data-testid="address-update-terms-continue-button"
                  size="mini"
                  skin="primary"
                  width="full-width"
                >
                  {shippingAddressUpdate.continue}
                </Button>
              </Column>
            </Row>
          </GridContainer>
        </ModalDialogButtons>
      </ModalDialogFooter>
    </>
  );
};

AddressUpdateTerms.propTypes = {
  setTermsAccepted: PropTypes.func.isRequired,
};
